module.exports = __webpack_public_path__ + "static/media/1POLICY28.3dbb6958.jpg";